import 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var StyledArrowPositioner = styled.span.withConfig({
  displayName: "ArrowPositioner__StyledArrowPositioner",
  componentId: "r0lo40-0"
})(["&&{line-height:0;", ";", ";", ";", ";}"], function (props) {
  return props.position === "bottom" && "\n        bottom: 100%;\n    ";
}, function (props) {
  return props.position === "top" && "\n        top: 100%;\n    ";
}, function (props) {
  return props.position === "right" && "\n        right: 100%;\n    ";
}, function (props) {
  return props.position === "left" && "\n        left: 100%;\n    ";
});

function ForwardRef(props, ref) {
  if (!props.children) return null;
  var positionString = props.placement ? props.placement.split("-")[0] : "bottom";
  var position = positionString;
  return /*#__PURE__*/jsx(StyledArrowPositioner, {
    position: position,
    ref: ref,
    style: props.style,
    children: props.children({
      position: position
    })
  });
}

ForwardRef.displayName = "ArrowPositioner";
var ArrowPositioner = /*#__PURE__*/React.forwardRef(ForwardRef);

export { ArrowPositioner };
